import React from 'react';
import BookingForm from '../components/BookingForm/BookingForm';
import './InnerPage.css';

export default function ContactPage() {
  return (
    <div className="inner-page">
      <div className="inner-hero" style={{ background: 'linear-gradient(135deg,#1a0530,#0D1B3E)' }}>
        <div className="inner-hero-content">
          <span className="inner-eyebrow">Reach Us</span>
          <h1>Contact <span className="gold">Us</span></h1>
          <p>Book a site visit, get property details, or just say hello — we're here 9 AM–7 PM</p>
        </div>
      </div>
      <BookingForm />
    </div>
  );
}
